<template>
  <span v-click-outside="handleClose" class="named-carts-tooltip">
    <span :class="{ 'named-carts-tooltip__beta': beta }">
      <span v-if="beta" class="named-carts-tooltip__beta-text">Beta</span>
      <button class="named-carts-tooltip__tooltip-trigger" type="button" @click="handleTrigger">
        <UseSvg
          class="named-carts-tooltip__info-icon icon icon--svg icon--info-circle-bold"
          icon="info-circle-bold"
          alt="Beta"
        />
      </button>
    </span>

    <span
      class="named-carts-tooltip__tooltip"
      :class="{ 'named-carts-tooltip__tooltip--open': savedCartsShowDateTooltip }"
    >
      <span class="named-carts-tooltip__tooltip-msg">
        {{ tooltipMsg }}
      </span>

      <button class="named-carts-tooltip__tooltip-button" type="button" @click="handleTrigger">
        Got it
      </button>
    </span>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UseSvg from "common/vue/components/UseSvg.vue";

export default {
  name: "NamedCartsTooltip",
  components: { UseSvg },
  props: {
    beta: {
      type: Boolean,
      default: false
    },
    tooltipMsg: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("savedCarts", ["savedCartsShowDateTooltip", "savedCartsShowDateTooltipOnce"])
  },
  methods: {
    handleClose() {
      if (!this.savedCartsShowDateTooltipOnce) {
        this.toggleSavedCartsDateTooltip(false);
      }
    },
    handleTrigger() {
      this.toggleSavedCartsDateTooltip(!this.savedCartsShowDateTooltip);
    },
    ...mapActions("savedCarts", ["toggleSavedCartsDateTooltip"])
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/button/mixin.scss";

.named-carts-tooltip {
  &__beta {
    display: inline-block;
    min-width: 60px;
    margin: -4px 0 0 4px;
    border-radius: 3px;
    padding: 2px;
    background-color: $red;
    color: $white;
    text-align: center;
    text-transform: uppercase;
  }

  &__beta-text {
    margin-right: 2px;
    font-size: 12px;
    font-weight: 700;
  }

  &__tooltip-trigger {
    @include clear-button;
    @include svg-wrapper;

    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: -4px;
  }

  &__tooltip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100vw - 52px);
    margin-bottom: 24px;
    margin-left: -12px;
    padding: 12px 16px;
    border-radius: 12px;
    background-color: $blue;
    box-shadow: 0 3px 6px rgba($black, 0.1);
    transform: translateY(-15px);
    color: $white;
    opacity: 0;
    pointer-events: none;

    &--open {
      transition:
        opacity ease-out 0.3s,
        transform ease-out 0.15s;
      transform: translateY(0);
      pointer-events: auto;
      opacity: 1;
    }

    @include with-tablet {
      width: 342px;
      margin-left: -96px;
    }
  }

  &__tooltip-msg {
    margin-right: 20px;
  }

  &__tooltip-button {
    flex-shrink: 0;
    padding: 8px 12px;
    border: 0;
    border-radius: 8px;
    background-color: $white;
    color: $primary;
    font-size: 14px;
    font-weight: 700;

    &:hover,
    &:focus {
      opacity: 0.7;
    }
  }
}
</style>
